module.exports = __webpack_public_path__ + "img/xj1.1bae5242.png";